class ReserveProductsDialog extends HTMLElement {
  reservedProducts = JSON.parse(sessionStorage.getItem('reservedProducts') || '[]');

  connectedCallback() {
    if (!this.reservedProducts.length) return;

    this.footer = document.querySelector('.shopify-section-group-footer-group');
    this.countElement = this.querySelector('.reserve-products-dialog__count');

    this.countElement.textContent = this.reservedProducts.length;

    this.observeElement();
  }

  observeElement() {
    const observer = new IntersectionObserver((entries) => {
      ['opacity-0', 'invisible'].forEach((className) => {
        this.classList.toggle(className, entries[0].isIntersecting);
      });
    });

    observer.observe(this.footer);
  }
}

customElements.define('reserve-products-dialog', ReserveProductsDialog);
